import { sourceRevision } from '../lib/translationAssurance.js';
import { NEONATAL_PARENT_STAGES, NEONATAL_PARENT_CONTENT } from './neonatalParentJourney.js';
import { NEONATAL_PREVIEW_UI_COPY } from './neonatalParentPreviewCopy.js';
import { NEONATAL_DRAFT_DISCLAIMER, NEONATAL_NATIONAL_SOURCES, NEONATAL_PARENT_MODULES, NEONATAL_ROLE_SUMMARIES, NEONATAL_WORDS } from './neonatalParentEducationDraft.js';

export const NEONATAL_PARENT_SOURCE_NAMESPACE = 'neonatalParent';
export const neonatalTermId = term => String(term).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');

export function buildNeonatalParentSourceRows() {
  const rows = [];
  const add = (path, sourceText, group, clinical = true) => {
    if (typeof sourceText !== 'string' || !sourceText.trim()) return;
    const id = 'neonatalParent:' + path;
    rows.push({ id, namespace: 'neonatalParent', path, sourceText,
      sourceRevision: sourceRevision(id, sourceText), contentArea: 'hospital_journeys',
      group, clinical, publicationTarget: 'editorial_review_only' });
  };
  add('title', 'Your Baby’s Neonatal Care', 'overview', false);
  Object.entries(NEONATAL_PREVIEW_UI_COPY).forEach(([key, value]) => add('ui.' + key, value, 'ui', false));
  add('warning.disclaimer', NEONATAL_DRAFT_DISCLAIMER, 'safety');
  NEONATAL_PARENT_STAGES.forEach(stage => {
    const prefix = 'stages.' + stage.id;
    add(prefix + '.title', stage.title, 'stage');
    add(prefix + '.description', stage.description, 'stage');
    Object.entries(stage.explanation).forEach(([key, value]) => add(prefix + '.explanation.' + key, value, 'clinical_explanation'));
  });
  NEONATAL_PARENT_CONTENT.questions.forEach((text, i) => add('questions.' + i, text, 'questions'));
  NEONATAL_PARENT_CONTENT.roles.forEach(role => add('roles.' + role.id + '.title', role.title, 'roles', false));
  NEONATAL_PARENT_CONTENT.usefulLinks.forEach(link => {
    add('localLinks.' + link.id + '.title', link.title, 'trust_placeholder', false);
    add('localLinks.' + link.id + '.description', link.description, 'trust_placeholder', false);
  });
  NEONATAL_PARENT_MODULES.forEach(module => {
    const prefix = 'modules.' + module.id;
    add(prefix + '.intro', module.intro, 'clinical_explanation');
    module.topics.forEach(topic => {
      const key = prefix + '.topics.' + topic.id;
      add(key + '.title', topic.title, 'clinical_topic');
      topic.paragraphs.forEach((text, i) => add(key + '.paragraphs.' + i, text, 'clinical_topic'));
    });
  });
  NEONATAL_WORDS.forEach(item => {
    const path = 'words.' + neonatalTermId(item.term);
    add(path + '.term', item.term, 'glossary');
    add(path + '.meaning', item.meaning, 'glossary');
  });
  NEONATAL_ROLE_SUMMARIES.forEach(role => {
    add('roleSummaries.' + role.id + '.title', role.title, 'roles', false);
    add('roleSummaries.' + role.id + '.description', role.description, 'roles');
  });
  NEONATAL_NATIONAL_SOURCES.forEach(source => add('sources.' + source.id + '.title', source.title, 'external_resources', false));
  if (new Set(rows.map(row => row.id)).size !== rows.length) throw new Error('Duplicate neonatal source IDs');
  return rows;
}
export const NEONATAL_PARENT_SOURCE_ROWS = Object.freeze(buildNeonatalParentSourceRows());
export const NEONATAL_PARENT_SOURCE_BY_PATH = Object.freeze(Object.fromEntries(NEONATAL_PARENT_SOURCE_ROWS.map(row => [row.path, row])));
